import React, { useEffect, useState } from "react";
import apiService from "../../../services/apiService";
import CustomToast from "../../Toast";
import { useTranslation } from "react-i18next";
import Video from "../microModuleDashboard/video"; // Adjust the import path as needed

const FullScreenImageModal = ({ imageUrl, onClose }) => (
  <div className="fullscreen-modal">
    <button type="button" onClick={onClose} className="close-button">
      Close 
    </button>
    <img src={imageUrl} alt="Fullscreen" className="fullscreen-image" />
  </div>
);

const Evaluation = ({
  courseDetails,
  course,
  Qdata,
  userAns,
  setCompleted,
  updateLmsModule,
  setIsVisible,
  setUserAnswers,
  setModuleContent,
  setIsSubmit,
  setRestrictTheSelect,
}) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const currentLang = course?.lang;
  const [showCorrectAns, setShowCorrectAns] = useState(false)

  const getLangCode = (lang) => {
    switch (lang) {
      case 'English':
        return 'en';
      case 'Hindi':
        return 'hi';
      case 'Marathi':
        return 'mar';
      default:
        return 'en';
    }
  };

  const langId = getLangCode(currentLang);
  const tForLang = i18n.getFixedT(langId);

  const pass = {
    title: tForLang('course_modules_test_pass_title'),
    line1: tForLang('course_modules_test_pass_line1'),
    line2: tForLang('course_modules_test_pass_line2'),
    line3: tForLang('course_modules_test_pass_line3'),
    button: tForLang('course_modules_test_pass_button'),
    color: "green",
  };
  const fail = {
    title: tForLang('course_modules_test_fail_title'), 
    line1: tForLang('course_modules_test_fail_line1'),
    line2: tForLang('course_modules_test_fail_line2'),
    line3: tForLang('course_modules_test_fail_line3'),
    button: tForLang('course_modules_test_fail_button'),
    color: "red",
  };
  const passed = {
    title: "Congratulations!",
    line1:
      "You have successfully completed the course. You can now view and download the certificate. Take care and stay safe!",
    button: "View Certificate",
  };

  // Function to calculate total marks
  function calculateTotalMarks(questions) {
    let totalMarks = 0;
    questions?.forEach((question) => {
      totalMarks += question.marks;
    });
    return totalMarks;
  }
  // Function to calculate total marks
  function calculateGetMarks(userData) {
    let totalMarks = 0;
    userData?.forEach((question) => {
      totalMarks += question.user_marks;
    });
    return totalMarks;
  }

  function passOrFail(totalMarks, obtainedMarks, passingPercentage) {
    const percentage = (obtainedMarks / totalMarks) * 100;
    return percentage >= passingPercentage ? pass : fail;
  }

  function passOrFailStatus(totalMarks, obtainedMarks, passingPercentage) {
    const percentage = (obtainedMarks / totalMarks) * 100;
    return percentage >= passingPercentage ? "pass" : "fail";
  }

  const [Evaluation, setEvaluation] = useState(
    passOrFail(
      calculateTotalMarks(Qdata?.questions),
      calculateGetMarks(userAns),
      Qdata?.passing_percent
    )
  );
  const [response, setResponse] = useState("");
  const [isPass, setIsPass] = useState(false);
  const [showContinueButton, setShowContinueButton] = useState(false);
 
 // const { t } = useTranslation();

  const retry = async () => {
    setCompleted(false);
    await setModuleContent([]);
    await setUserAnswers([]);
    Qdata.questions = shuffleArray(Qdata.questions)
    setModuleContent(Qdata);
    setRestrictTheSelect(false)
    setIsSubmit(true);
    setShowCorrectAns(false);
    window.location.reload();
  };

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
  
  const submit = () => {
    setRestrictTheSelect(true)
    Evaluation?.button === "Try Again" || Evaluation?.button == "फिर से प्रयास करें।" 
    ? retry()
      : updateLmsModule(userAns, "test", true);
  };

  const submitUserTestResult = async () => {
    try {
      const payload = {
        course_id: courseDetails?.course_id,
        user_id: courseDetails?.user_id,
        org_id: courseDetails?.org_id,
        test_type: Qdata?.course_test_type,
        total_marks: calculateTotalMarks(Qdata?.questions),
        user_attempts: 1,
        user_marks: calculateGetMarks(userAns),
        totalAttempt: Qdata?.max_attempts,
        user_course_status: passOrFailStatus(
          calculateTotalMarks(Qdata?.questions),
          calculateGetMarks(userAns),
          Qdata?.passing_percent
        ),
        completion_percent: ""
      };
      const token = apiService.getAuthToken();
      const result = await apiService.postLms(
        "saveUserTestResult",
        payload,
        token
      );
      if (result && result.status == "success") {
        console.log(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(()=>{
  //   submitUserTestResult()
  // },[])

  const getCertificate = async () => {
    let user_details = sessionStorage.getItem("user_details");
    let data = {
      course_id: courseDetails?.course_id,
      send_email: true,
      user_id:  JSON.parse(user_details)?.uid,
    };
    const token = apiService.getAuthToken();
    await apiService.postV1(`generate-certificate`, data, token);
  };

  return (
    <div className="custom-overlay video-questions quiz">
      <div className="d-flex flex-column justify-content-center align-items-center text-center">
        <div className="card mw-500 p-3">
          <a
            className="w-100 text-end test-decoration-none"
            onClick={() => {
              setIsVisible(true);
              setCompleted(false);
              setShowCorrectAns(true);
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 29 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.548828"
                width="27.4625"
                height="27.4517"
                rx="13.7259"
                fill="#146B90"
              />
              <path
                d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z"
                fill="white"
              />
            </svg>
          </a>
          <form className="m-3 mt-0">
            <h3 className="fw-bold font-26 mb-4">{Evaluation.title}</h3>
            <ul className="d-flex flex-column justify-content-start mcq-options">
              <h4 className="font-28" style={{ color: `${Evaluation.color}` }}>
                <b>
                  {calculateGetMarks(userAns)}/
                  {calculateTotalMarks(Qdata?.questions)}
                </b>
              </h4>
              <p className="mb-4">{tForLang('course_modules_test_scores')}</p>
              <p className="mb-2">{Evaluation.line1}</p>
              <p className="mb-4">{Evaluation.line2}</p>
              {/* <p className="mb-3">{Evaluation.line3}</p> */}
            </ul>
            {/* {Evaluation?.button == "Try Again" || Evaluation?.button == "फिर से प्रयास करें।" ? ( */}
              <button
                className="btn btn-md btn-primary"
                type="button"
                onClick={() => {
                  setIsVisible(true);
                  setCompleted(false);
                  setShowCorrectAns(true);
                }}
              >
                {tForLang('course_modules_show_test_result')}
              </button>
            {/* ) : null} */}
            &nbsp;&nbsp;
            <button
              className="btn btn-md btn-primary"
              type="button"
              onClick={submit}
            >
              {Evaluation?.button}
            </button>
          </form>
          {/* //  : <form className='m-3' >
      //     <h3 className='fw-bold font-26 mb-4'>{passed.title}</h3>
      //     <ul className='d-flex flex-column justify-content-start mcq-options'>
      //       <p>{passed.line1}</p>
      //     </ul>
      //     <button className='btn btn-md btn-primary' type="button"  onClick={getCertificate}>
      //       {passed?.button}
      //     </button>
      //   </form> */}
        </div>
      </div>
    </div>
  );
};

const Quiz = ({ moduleContents, courseDetails, updateLmsModule, isPass, course, lastCompletedModuleId, completedModules, selectedAns = {}, onAnswersChange }) => {
  const [answers, setAnswers] = useState({});
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);
  const [completed, setCompleted] = useState(false);
  const [isVideoWatchComplete, setIsVideoWatchComplete] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isShow, setIsShow] = useState(true);
  const [isSubmit, setIsSubmit] = useState(true); // true = next button disabled, false = next button enabled
  const [moduleContent, setModuleContent] = useState(moduleContents);
  const [disabledSubmit, setDisabledSubmit] = useState(false) // false = submit button enabled, true = submit button disabled
  const [restrictTheSelect, setRestrictTheSelect] = useState(false);
  const { t } = useTranslation();
  const [isUserPass, setIsUserPass] = useState(false)
  const [showCorrectAns, setShowCorrectAns] = useState(false)
   // Add state to track video question answer feedback
  const [showVideoAnswerFeedback, setShowVideoAnswerFeedback] = useState(false);
  const { i18n } = useTranslation();
  const currentLang = course?.lang;
  let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));
  let microCourseId = localStorage.getItem("microCourseId");
  const [userData, setUserData] = useState({});
  const [previousAnswers, setPreviousAnswers] = useState({});
  const [isQuizSubmitted, setIsQuizSubmitted] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    // Watch for changes in userAnswers and send selected_ans to parent
    useEffect(() => {
        if (userAnswers.length > 0 && onAnswersChange) {
            // Transform userAnswers to selected_ans format
            const selected_ans = userAnswers.reduce((map, answer) => {
                map[answer.qid] = answer.user_answer;
                return map;
            }, {});
            
            // Call the callback to send selected_ans to microModuleDashboard
            onAnswersChange(selected_ans);
        }
    }, [userAnswers, onAnswersChange]);
    
   const fetchData = async () => {
        try {
            const token = apiService.getAuthToken()
            const result = await apiService.get('get-org-user-info', token);
            if (result && result?.status == "success") {
                setUserData(result?.data);
            }
        } catch (error) {
            ///setError('Error fetching user data');
            console.error(error);
        }
    };
   
  const getLangCode = (lang) => {
    switch (lang) {
      case 'English':
        return 'en';
      case 'Hindi':
        return 'hi';
      case 'Marathi':
        return 'mar';
      default:
        return 'en';
    }
  };

  const langId = getLangCode(currentLang);
  const tForLang = i18n.getFixedT(langId);
  const [showAndHide, setShowAndHide] = useState(tForLang('course_modules_show_result'));

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // moduleContent.questions = shuffleArray(moduleContent.questions)
    setModuleContent(moduleContents);
    
    // If module is completed, show correct answers immediately and handle button states
    if (moduleContents?.is_completed) {
      setShowCorrectAns(true);
      setIsQuizSubmitted(true); // Mark as submitted if already completed
      setDisabledSubmit(true); // Disable submit button
      
      // Extract previous answers from moduleContents if available
      if (moduleContents?.questions) {
        const extractedAnswers = {};
        moduleContents.questions.forEach(question => {
          if (question.user_answer && question.user_answer.length > 0) {
            extractedAnswers[question.qid] = question.user_answer;
          }
        });
        setPreviousAnswers(extractedAnswers);
      }
      
      // If it's a general test and module is completed
      if (moduleContents?.course_test_type === "general_line") {
        setIsVisible(true);
        setIsSubmit(false); // Enable next button
      } else {
        setIsSubmit(false); // Enable next button for other test types too
      }
    } else {
      // Reset states when module changes or is not completed
      setDisabledSubmit(false);
      setIsQuizSubmitted(false); // Reset quiz submission state
      setPreviousAnswers({}); // Clear previous answers
      // When loading a new non-completed module, enable submit button and disable next button
      setIsSubmit(true);
      
      // Check if this is a general_line test with answers already submitted but module not marked as completed
      if (moduleContents?.course_test_type === "general_line" && 
          Array.isArray(moduleContents?.questions) && 
          moduleContents?.questions.some(q => Array.isArray(q.user_answer) && q.user_answer.length > 0)) {
        // This means user has submitted answers but not clicked Next
        setDisabledSubmit(true);
        setIsSubmit(false); // Enable next button
      }
    }
  }, [moduleContents]);

  const retry = async () => {
    // setCompleted(false)
    setIsSubmit(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
    await setModuleContent([]);
    await setUserAnswers([]);
    moduleContent.questions = shuffleArray(moduleContent.questions)
    setModuleContent(moduleContents);
    setIsVisible(false);
    setShowCorrectAns(false);
  };

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  const hideShowGeneralQuestion = () => {
    if (isShow) {
      setIsShow(false);
      setShowAndHide(tForLang('course_modules_show_result'));
    } else {
      setIsShow(true);
      setShowAndHide(tForLang('course_modules_hide_result'));
    }
  };

  const handleMarkAsCompleted = (userAnswers, value) => {
    // Check if already submitted
    // if (isQuizSubmitted) {
    //   CustomToast.info("Quiz has already been submitted. You cannot resubmit.");
    //   return;
    // }

    if (userAnswers?.length == moduleContent?.questions?.length) {
      submitUserTestResult();
      setIsSubmit(false);
      setShowCorrectAns(true); // Ensure correct answers are shown after submission
      setIsQuizSubmitted(true); // Mark as submitted
      window.scrollTo({ top: 0, behavior: "smooth" });
      setCompleted(true);
    } else {
      CustomToast.error(tForLang('toast_messages_questions_submit_test_error'));
    }
  };

  function getTotalLength(arr) {
    return arr.reduce((total, obj) => {
      if (obj.sub_questions.length > 1) {
        // Add length of nested array 'l' within the object
        total += obj.sub_questions.length;
      } else {
        total += 1;
      }

      return total;
    }, 0);
  }

  // Function to calculate total marks
  function calculateTotalMarks(questions) {
    let totalMarks = 0;
    questions?.forEach((question) => {
      totalMarks += question.marks;
    });
    return totalMarks;
  }
  // Function to calculate total marks
  function calculateGetMarks(userData) {
    let totalMarks = 0;
    userData?.forEach((question) => {
      totalMarks += question.user_marks;
    });
    return totalMarks;
  }

  function passOrFailStatus(totalMarks, obtainedMarks, passingPercentage) {
    const percentage = (obtainedMarks / totalMarks) * 100;
    return percentage >= passingPercentage ? "pass" : "fail";
  }

  const submitUserTestResult = async () => {
    let user_details = sessionStorage.getItem("userDetail");
    let selectedLanguage = localStorage.getItem("selectedLanguage");
    try {
      //check user or fail
      const userTestResult = passOrFailStatus(
        calculateTotalMarks(moduleContent?.questions),
        calculateGetMarks(userAnswers),
        moduleContent?.passing_percent
      )
      // const payload = {
      //   course_id: '684fd7f0820a43303c2bd614',
      //   user_id: JSON.parse(user_details)?.uid,
      //   org_id: orgInfo?.org_id,
      //   test_type: moduleContent?.course_test_type,
      //   total_marks: calculateTotalMarks(moduleContent?.questions),
      //   user_attempts: 1,
      //   user_marks: calculateGetMarks(userAnswers),
      //   totalAttempt: moduleContent?.max_attempts,
      //   user_course_status: userTestResult,
      //   completion_percent: courseDetails?.completion_percent?.toString(),
      //   test_lang: localStorage.getItem('userLang') || 'English'
      // };

    // Transform userAnswers from array format to object format
    const selected_ans = userAnswers.reduce((map, answer) => {
      map[answer.qid] = answer.user_answer;
      return map;
    }, {});

      const payload = {
        org_id: orgInfo?.org_id,
        email: userData?.email,
        user_id: userData?.uid,
        micro_course_id: microCourseId,
        lang_id: JSON.parse(selectedLanguage)?.id,
        module_id: moduleContent?.module_id,
        module_content_id: moduleContent?._id,
        selected_ans: selected_ans,
        module_status: "completed",
      //  course_status: "pending",
        last_module_id: lastCompletedModuleId || null,
      };

      if(userTestResult == "pass") {
        setIsUserPass(true)
      }
      const token = apiService.getAuthToken();
      const result = await apiService.postLms(
        "saveUserMicroCourseAns",
        payload,
        token
      );
      if (result && result.status) {
        // Set previous answers from the current user answers for future reference
        const selected_ans = userAnswers.reduce((map, answer) => {
          map[answer.qid] = answer.user_answer;
          return map;
        }, {});
        setPreviousAnswers(selected_ans);
        
        // Mark quiz as submitted to prevent resubmission
        setIsQuizSubmitted(true);
        setShowCorrectAns(true);
        setIsSubmit(false);
        setCompleted(true);
        setDisabledSubmit(true); // Disable submit button
  
        // Notify parent component about module completion
        if (updateLmsModule && moduleContent?.module_id) {
          updateLmsModule(moduleContent.module_id);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAlreadyMarkAsCompleted = (userAnswers, value, type) => {
    // Check if already submitted
    // if (isQuizSubmitted) {
    //   CustomToast.info("Quiz has already been submitted. You cannot resubmit.");
    //   return;
    // }

    // If it's a general test ("G" type) and the button is already disabled, prevent further processing
    if (type === "G" && disabledSubmit) {
      return;
    }
    
    if (userAnswers && userAnswers.length > 0) {
      submitUserTestResult();
    }
    
    if (type === "G") {
      // Check if all questions have been answered
      if (userAnswers?.length === moduleContent?.questions?.length) {
        // Disable the submit button immediately to prevent double submissions
        setDisabledSubmit(true);
        setIsVisible(true);
        // Set isSubmit to false to enable the Next button
        setIsSubmit(false);
        setShowCorrectAns(true);
        setIsQuizSubmitted(true); // Mark as submitted
        
        // Call the API to submit the test results
        // updateLmsModule(userAnswers, "test", value, type).then((res) => {
        //   // Keep submit button disabled after successful submission
        //   console.log("General test submitted successfully");
        //   CustomToast.success(tForLang('toast_messages_test_submitted'));
        // }).catch((error) => {
        //   // If API call fails, re-enable the submit button to allow retrying
        //   console.error("Error submitting general test:", error);
        //   setDisabledSubmit(false);
        //   setIsSubmit(true); // Disable Next button if submission fails
        //   CustomToast.error(tForLang('toast_messages_submit_error'));
        // });
        
        return;
      } else {
        CustomToast.error(tForLang('toast_messages_questions_submit_test_error'));
        return;
      }
    } 
    
    // if (value) {
    //   if (moduleContent?.questions.length !== userAnswers?.length) {
    //     CustomToast.error(tForLang('toast_messages_questions_submit_test_error'));
    //   } else {
    //     updateLmsModule(userAnswers, "test", value, type).then((res) => {
    //       // if (res && Object.keys(res).length && res?.moduleContents && type =="G") {
    //       //   window.location.reload(true);
    //       // } else {
    //       //   if(moduleContent?.course_test_type == "base_line" && !moduleContent?.is_completed) {
    //       //     setUserAnswers([]);
    //       //   }
    //       // }
    //     });
    //   }
    // } 
    else {
      updateLmsModule(userAnswers, "test", value, type).then((res) => {
        // if (res && Object.keys(res).length && res?.moduleContents) {
        //   setModuleContent(res?.moduleContents);
        //   setUserAnswers([]);
        // } else {
        //   setUserAnswers([]);
        // }
      });
    }
    // .then(data=>{
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    // setCompleted(true);
    // console.log(data,"ldskmkmdimdoifc");
    //  }).catch((error)=>{
    // console.log(error,"ndsjcnsdnvcdsi");
    //  })
    //  console.log("sdfsdds",data);
  };
  
  const handleImageFullScreen = (imageUrl) => {
    setFullscreenImage(imageUrl);
  };

  const handleCloseFullscreen = () => {
    setFullscreenImage(null);
  };

  const handleSliderChange = (value, questionId, index) => {
    // setAnswers((prevAnswers) => ({ ...prevAnswers, [questionId]: value }));
    // setUserAnswers((prevAnswers) => ({ ...prevAnswers, [questionId]: value }))
    const isUserCorrect = checkUserCorrectnessOnSlider(questionId, value);
    // Check if the question is already present in userAnswers
    const existingAnswerIndex = userAnswers?.findIndex(
      (ans) => ans?.qid === questionId
    );

    if (existingAnswerIndex !== -1) {
      // If the question exists, update the existing entry
      setUserAnswers((prevAnswers) => [
        ...prevAnswers.slice(0, existingAnswerIndex),
        {
          is_user_correct: isUserCorrect,
          user_answer: [value],
          qid: questionId,
          user_marks: isUserCorrect
            ? moduleContent?.questions[index - 1]?.marks
            : 0,
          course_test_type: moduleContent?.course_test_type  
        },
        ...prevAnswers.slice(existingAnswerIndex + 1),
      ]);
    } else {
      // If the question does not exist, add a new entry
      setUserAnswers((prevAnswers) => [
        ...prevAnswers,
        {
          is_user_correct: isUserCorrect,
          user_answer: [value],
          qid: questionId,
          user_marks: isUserCorrect
            ? moduleContent?.questions[index - 1]?.marks
            : 0,
          course_test_type: moduleContent?.course_test_type   
        },
      ]);
    }
  };

  // Function to check if user's answer is correct
  const checkUserCorrectnessOnSlider = (questionId, selectedOptions) => {
    const question = moduleContent?.questions.find((q) => q.qid === questionId);
    if (!question) {
      console.error(`Question with id ${questionId} not found.`);
      return false;
    }

    return selectedOptions == question?.rating?.ans;
  };

  const renderSliderFeedback = (question, questionNumber, length) => {
    const updateSliderStyle = (sliderId, value, max) => {
      const progress =
        ((value - question.rating.min) / (max - question.rating.min)) * 100;
      const rangeSlider = document.getElementById(sliderId);
      if (rangeSlider) {
        rangeSlider.style.background = `linear-gradient(to right, #146B90 0%, #146B90 ${progress}%, #ddd ${progress}%, #ddd 100%)`;
      }
    };

    return (
      <div>
        {length > 1 ? (
          <h3 className="fw-bold font-20 text-dark-grey">{tForLang('course_modules_question')} {`${questionNumber}`}</h3>
        ) : null}
        <div dangerouslySetInnerHTML={{ __html: question?.content }} />
        <div className="sliderticks">
          {question &&
            question.rating &&
            Array.from(
              {
                length:
                  (question.rating.max - question.rating.min) /
                    question.rating.interval +
                  1,
              },
              (_, index) => (
                <span key={index}>
                  {question.rating.min + index * question.rating.interval}
                </span>
              )
            )}
        </div>
        <input
          type="range"
          id={`range-slider-${questionNumber}`}
          min={question?.rating?.min}
          max={question?.rating?.max}
          step={question?.rating?.interval}
          disabled={Array.isArray(question?.user_answer) && question?.user_answer?.length > 0}
          onChange={(e) => {
            updateSliderStyle(
              `range-slider-${questionNumber}`,
              parseInt(e.target.value, 10),
              e.target.max
            );
            handleSliderChange(
              parseInt(e.target.value, 10),
              question.qid,
              questionNumber
            );
          }}
          onInput={(e) => {
            updateSliderStyle(
              `range-slider-${questionNumber}`,
              parseInt(e.target.value, 10),
              e.target.max
            );
          }}
        />
        <p className="font-16 text-dark-grey" id="satisfaction-level">
          Your satisfaction level:{" "}
          {
            userAnswers?.find((item) => item.qid === question.qid)
              ?.user_answer[0]
          }
        </p>
        {renderFeedback(question)}
      </div>
    );
  };

  const renderFeedback = (question) => {
    const satisfactionLevel = answers[question.id] || question.min;
    const matchingFeedback = question?.feedback?.find(
      (feedback) =>
        satisfactionLevel >= feedback?.min && satisfactionLevel <= feedback?.max
    );
    return (
      <p className="font-16 text-dark-grey">
        {matchingFeedback ? matchingFeedback.text : ""}
      </p>
    );
  };

  const handleSubmit = () => {
    const results = moduleContent.questions.map((question) => {
      const selectedAnswer = answers[question.id];
      const isCorrect = Array.isArray(selectedAnswer)
        ? selectedAnswer.sort().toString() ===
          question.correctAnswer.sort().toString()
        : selectedAnswer === question.correctAnswer;
      return isCorrect;
    });

    // onQuizSubmit(results);
  };
  // <option value='rating'>Rating</option>

  // Function to handle user selection for a question
  const handleOptionSelect = (questionId, selectedOptions, index) => {
    setIsVisible(false);
    const isUserCorrect = checkUserCorrectness(questionId, selectedOptions);
    // Check if the question is already present in userAnswers
    const existingAnswerIndex = userAnswers?.findIndex(
      (ans) => ans?.qid === questionId
    );
    if (existingAnswerIndex !== -1) {
      // If the question exists, update the existing entry
      setUserAnswers((prevAnswers) => [
        ...prevAnswers.slice(0, existingAnswerIndex),
        {
          is_user_correct: isUserCorrect,
          user_answer: Array.isArray(selectedOptions)
            ? selectedOptions
            : [selectedOptions],
          qid: questionId,
          user_marks: isUserCorrect
            ? moduleContent?.questions[index - 1]?.marks
            : 0,
          course_test_type: moduleContent?.course_test_type  
        },
        ...prevAnswers.slice(existingAnswerIndex + 1),
      ]);
    } else {
      // If the question does not exist, add a new entry
      setUserAnswers((prevAnswers) => [
        ...prevAnswers,
        {
          is_user_correct: isUserCorrect,
          user_answer: Array.isArray(selectedOptions)
            ? selectedOptions
            : [selectedOptions],
          qid: questionId,
          user_marks: isUserCorrect
            ? moduleContent?.questions[index - 1]?.marks
            : 0,
          course_test_type: moduleContent?.course_test_type
        },
      ]);
    }
  };

  const renderQuestionContent = (
    question,
    questionNumber,
    passing_percent,
    length,
    is_completed,
    is_started,
    course_test_type,
    course,
    showCorrectAnsParam = showCorrectAns, // Default to component state
    showVideoAnswerFeedbackParam = showVideoAnswerFeedback // For video questions
  ) => {
    function isCorrectById(id, user_answer) {
      if(user_answer?.length > 1) {
        return isMultipleCorrectById(user_answer)
      } else {
        const filterOptions = question.options?.filter((ele => ele?.is_correct))
        if(filterOptions?.length > 1 && user_answer?.length == 1) {
          return false
        } else {
          const match = question.options?.find(
            (item) => item._id === id && item.is_correct
          );
          return !!match;
        }
      }
    }

    function isMultipleCorrectById(userAnswers) {
      // Filter correct options from the question's options
      const correctOptions = question?.options?.filter(option => option.is_correct);
      // If there are no correct options or only one correct option, return false
      if (!correctOptions || correctOptions?.length <= 1) {
        return false;
      }
    
      // Check if the user answers match the correct options
      const allAnswersCorrect = userAnswers?.every(userAnswer => 
        correctOptions?.some(correctOption => correctOption._id === userAnswer)
      );
    
      // Return true if the number of user answers matches the number of correct options and all answers are correct
      return userAnswers?.length === correctOptions.length && allAnswersCorrect;
    }

    switch (question.question_type) {
      case "single_choice":
      case "multi_choice":
      case "bool":
        return (
          <div>
            {console.log("length====>", length)}
             {length !== 1 ? (
              <h3 className="question-title question-label-custom px-2 
              py-2 mb-3 fw-bold font-18 text-dark-grey m-0">
                {tForLang("course_modules_question")} {questionNumber}
              </h3>
            ) : null}
            <div dangerouslySetInnerHTML={{ __html: question?.content }} />
            <ul className="mcq-options">
              {question?.options?.map((option, index) => {
                // Find user answer for this question
                const userAnswerObj = userAnswers.find(ans => ans.qid === question.qid);
                const isUserSelected = userAnswerObj?.user_answer?.includes(option._id) || 
                                      ((moduleContent?.is_completed || course?.course_status === "completed") && Array.isArray(question?.user_answer) && question?.user_answer?.includes(option._id));
                const isCorrect = option?.is_correct;
                
                // Determine className based on submission status and correctness
                let className = 'mx-3 mt-3 mb-0'; 
                
                // Show correct/incorrect classes after submit OR if module is completed
                if ((showCorrectAnsParam || showVideoAnswerFeedbackParam || moduleContent?.is_completed || course?.course_status === "completed") &&
                  (question?.ans_view !== "not_show_ans") &&
                  (isShow || isVisible) &&
                  (userAnswerObj || ((moduleContent?.is_completed || course?.course_status === "completed") && Array.isArray(question?.user_answer) && question?.user_answer?.length > 0))) {

                  if (isUserSelected) {
                    // User selected this option
                    className = isCorrect ? 'correct-option' : 'incorrect-option';

                    // } else if (isCorrect && 
                    //           ((userAnswerObj && !userAnswerObj.is_user_correct) || 


                  } else if (isCorrect) {
                    // For multi-choice questions, always show all correct options 
                    // For single-choice questions, show correct option if user got it wrong 
                    if (question.question_type === "multi_choice" ||
                      (userAnswerObj && !userAnswerObj.is_user_correct) ||
                      ((moduleContent?.is_completed || course?.course_status === "completed") && Array.isArray(question?.user_answer) && question?.user_answer?.length > 0 && !question?.user_answer?.every(ans =>
                        question?.options?.find(opt => opt._id === ans)?.is_correct))) {

                      // Show correct option if user got the question wrong
                      className = 'correct-option';
                    }
                  }
                } 
                
                return (
                  <li key={index} className={className}>
                    <label className={
                          question.question_type === "single_choice" ||
                          question.question_type === "bool"
                            ? "radio-button-container"
                            : "checkbox-button-container"
                        }>
                      <input
                        type={
                          question.question_type === "single_choice" ||
                          question.question_type === "bool"
                            ? "radio"
                            : "checkbox"
                        }
                        name={`question_${question._id}`}
                        value={option._id}
                        checked={
                          // Check if the option is in the user's saved answers from the server
                          (Array.isArray(question?.user_answer) && question?.user_answer?.includes(option._id)) ||
                          // Or check if it's in the user's current selections
                          userAnswers.find(ans => ans.qid === question.qid)?.user_answer?.includes(option._id) ||
                          // Or check if it's in the previous answers from API
                          (previousAnswers[question.qid] && previousAnswers[question.qid].includes(option._id))
                        }
                       
                        disabled={
                          (Array.isArray(question?.user_answer) && question?.user_answer?.length > 0) || 
                          !isSubmit || 
                          isQuizSubmitted ||
                          (previousAnswers[question.qid] && previousAnswers[question.qid].length > 0)
                        }
                        onChange={(e) => {
                          const selectedOptions =
                            question.question_type === "single_choice" ||
                          question.question_type === "bool"
                              ? e.target.value
                              : e.target.checked
                              ? [
                                  ...(userAnswers.find(
                                    (ans) => ans.qid === question.qid
                                  )?.user_answer || []),
                                  option._id,
                                ]
                              : (
                                  userAnswers.find(
                                    (ans) => ans.qid === question.qid
                                  )?.user_answer || []
                                ).filter((opt) => opt !== option._id);
                          handleOptionSelect(
                            question.qid,
                            selectedOptions,
                            questionNumber
                          );
                        }}
                      />
                      {Array.isArray(question?.user_answer) && question?.user_answer?.length > 0 ? <span className={option?.is_correct ? 'checkmark correct-check' : 'checkmark incorrect-check'}></span> : <span className="checkmark"></span>}  
                      <div
                        dangerouslySetInnerHTML={{ __html: option?.content }}
                      />
                    </label>
                  </li>
                );
              })}
              {Array.isArray(question?.user_answer) && (question?.user_answer?.length > 1 ? [question?.user_answer[0]] : question?.user_answer)?.map((itemQ, i) =>
                isShow &&
                (question?.ans_view == "show_ans_with_exp") ? (
                  <div key={i} className="w-100 text-start my-4">
                    <div
                      className={
                        isCorrectById(itemQ, question?.user_answer)
                          ? "correct p-3"
                          : "incorrect p-3 flex-column align-items-start"
                      }
                    >
                      <span>
                        {isCorrectById(itemQ, question?.user_answer) ? (
                          <p className="mb-3 fw-bold">{tForLang('course_modules_correct')} </p>
                        ) : (
                          <p className="mb-0 fw-bold">{tForLang('course_modules_incorrect')} </p>
                        )}
                        {/* {!isCorrect && */}
                        <span className="mb-0 text-black">
                          {question?.ans_view == "show_ans_with_exp" ? (
                            <div>
                              {isCorrectById(itemQ, question?.user_answer) ? (
                                <div className="my-2">
                                  <p className="mt-2">
                                     <div dangerouslySetInnerHTML={{ __html: question?.crt_ans_exp }} />
                                  </p>
                                </div>
                              ) : (
                                <p className="mb-0">
                                  {" "}
                                  {<div dangerouslySetInnerHTML={{ __html: question?.wrng_ans_exp }} /> ? (
                                    <div className="my-2"></div>
                                  ) : null}
                                   <div dangerouslySetInnerHTML={{ __html: question?.wrng_ans_exp }} />
                                </p>
                              )}
                            </div>
                          ) : null}

                          {/* {!isCorrectById(itemQ, question?.user_answer) ? (
                            <span className="fw-bold">
                              {" "}
                              <div className="mb-3">
                              {tForLang('course_modules_correct_answer')}:
                              </div>{" "}
                              {question?.options?.map((option, index) =>
                                option?.is_correct ? (
                                  <ul
                                    className={
                                      question.question_type ===
                                        "single_choice" ||
                                      question.type === "bool"
                                        ? "nopoints"
                                        : "points"
                                    }
                                  >
                                    <li key={option?._id} 
                                      style={{
                                        fontWeight: "normal",
                                        marginBottom: 0,
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: option?.content,
                                      }}
                                    />
                                  </ul>
                                ) : null
                              )}
                            </span>
                          ) : null} */}
                        </span>
                      </span>
                    </div>
                  </div>
                ) : null
              )}
              {userAnswers?.map((itemQ) =>
                isVisible &&
                question?.qid == itemQ?.qid &&
                (question?.ans_view == "show_ans_with_exp") ? (
                  <div className="w-100 text-start my-4">
                    <div
                      className={
                        itemQ?.is_user_correct
                          ? "correct p-3"
                          : "incorrect p-3 flex-column align-items-start"
                      }
                    >
                      <span>
                        {itemQ?.is_user_correct ? (
                          <p className="mb-3 fw-bold">{tForLang('course_modules_correct')}</p>
                        ) : (
                          <p className="mb-0 fw-bold">{tForLang('course_modules_incorrect')}</p>
                        )}
                        {/* {!isCorrect && */}
                        <span className="mb-0 text-black">
                          {question?.ans_view == "show_ans_with_exp" ? (
                            <div>
                              {itemQ?.is_user_correct ? (
                                <div className="my-2">
                                  <p className="mt-2">
                                    <div dangerouslySetInnerHTML={{ __html: question?.crt_ans_exp }} />
                                  </p>
                                </div>
                              ) : (
                                <p className="mb-0">
                                  {" "}
                                  {<div dangerouslySetInnerHTML={{ __html: question?.wrng_ans_exp }} /> ? (
                                    <div className="my-2"></div>
                                  ) : null}
                                 <div dangerouslySetInnerHTML={{ __html: question?.wrng_ans_exp }} />
                                </p>
                              )}
                            </div>
                          ) : null}

                          {/* {!itemQ?.is_user_correct ? (
                            <span className="fw-bold">
                              <div className="mb-3">{tForLang('course_modules_correct_answer')}:</div>{" "}
                              {question?.options?.map((option, index) =>
                                option?.is_correct ? (
                                  <ul
                                    className={
                                      question.question_type ===
                                        "single_choice" ||
                                      question.type === "bool"
                                        ? "nopoints"
                                        : "points"
                                    }
                                  >
                                    <li key={option?._id} 
                                      style={{
                                        fontWeight: "normal",
                                        marginBottom: 0,
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: option?.content,
                                      }}
                                    />
                                  </ul>
                                ) : null
                              )}
                            </span>
                          ) : null} */}
                        </span>
                      </span>
                    </div>
                  </div>
                ) : null
              )}
            </ul>
          </div>
        );

        case "para":
        return (
          <div>
            {length > 1 ? (
              <h3 className="fw-bold font-20 text-dark-grey">
                {tForLang("course_modules_question")} {`${questionNumber}`}
              </h3>
            ) : null}
            <div dangerouslySetInnerHTML={{ __html: question?.content }} />
            <ul className="mcq-questions ps-0">
              {question?.sub_questions?.map((sub_questions, index) => (
                <div key={index} className="mt-4">
                   <h3 className="question-label-custom fw-bold px-2 py-2 mb-3">
                      {tForLang("course_modules_question")} {`${index + 1}`}
                    </h3>
                  <div className="d-flex justify-content-start pt-2">
                    {/* <span className="fw-semibold me-2">
                      {`Q. ${index + 1}`}{" "}
                    </span> */}
                    <div
                      className="sub-question"
                      dangerouslySetInnerHTML={{
                        __html: sub_questions?.content,
                      }}
                    />
                  </div>
                  <ul className="mcq-options">
                    {sub_questions?.options?.map((option, optIndex) => {
                      const userAnswerObj = userAnswers.find(
                        (ans) => ans.qid === sub_questions.qid
                      );
                      const isUserSelected =
                        userAnswerObj?.user_answer?.includes(option._id) ||
                        (moduleContent?.is_completed &&
                          sub_questions?.user_answer?.includes(option._id));
                      const isCorrect = option?.is_correct;

                      let className = "mx-3 mt-3 mb-0";

                      if (
                        (showCorrectAnsParam || showVideoAnswerFeedbackParam || moduleContent?.is_completed || course?.course_status === 'completed') &&
                        (sub_questions?.ans_view !== "not_show_ans") &&
                        (isShow || isVisible) &&
                        (userAnswerObj ||
                          (moduleContent?.is_completed &&
                            sub_questions?.user_answer?.length > 0))
                      ) {
                        if (isUserSelected) {
                          className = isCorrect
                            ? "correct-option"
                            : "incorrect-option";
                        } else if (isCorrect) {
                          // For multi-choice questions, always show all correct options
                          // For single-choice questions, show correct option if user got it wrong
                          if (sub_questions.question_type === "multi_choice" ||
                              (userAnswerObj && !userAnswerObj.is_user_correct) ||
                              (moduleContent?.is_completed &&
                                sub_questions?.user_answer?.length > 0 &&
                                !sub_questions?.user_answer?.every(
                                  (ans) =>
                                    sub_questions?.options?.find(
                                      (opt) => opt._id === ans
                                    )?.is_correct
                                ))) {
                            className = "correct-option";
                          }
                        }
                      }

                      return (
                        <li key={optIndex} className={className}>
                          <label
                            className={
                              sub_questions.question_type === "single_choice" ||
                                sub_questions.question_type === "bool"
                                ? "radio-button-container"
                                : "checkbox-button-container"
                            }
                          >
                            <input
                              type={
                                sub_questions.question_type ===
                                  "single_choice" ||
                                  sub_questions.question_type === "bool"
                                  ? "radio"
                                  : "checkbox"
                              }
                              name={`question_${sub_questions._id}`}
                              value={option._id}
                              // disabled={sub_questions?.user_answer?.length > 0}
                                disabled={
                                moduleContent?.course_test_type === "base_line" ? moduleContent?.is_completed : (sub_questions?.user_answer?.length > 0 || !isSubmit)
                              }
                              checked={sub_questions?.user_answer?.includes(
                                option._id
                              )}
                              onChange={(e) => {
                                const selectedOptions =
                                  sub_questions?.question_type ===
                                    "single_choice" ||
                                    sub_questions.question_type === "bool"
                                    ? [e.target.value]
                                    : e.target.checked
                                      ? [
                                        ...(userAnswers.find(
                                          (ans) =>
                                            ans?.qid === sub_questions.qid
                                        )?.user_answer || []),
                                        option._id,
                                      ]
                                      : (
                                        userAnswers.find(
                                          (ans) => ans.qid === sub_questions.qid
                                        )?.user_answer || []
                                      ).filter((opt) => opt !== option._id);
                                handleOptionSelect(
                                  sub_questions.qid,
                                  selectedOptions,
                                  questionNumber
                                );
                              }}
                            />
                            {sub_questions?.user_answer?.length > 0 ? (
                              <span
                                className={
                                  option?.is_correct
                                    ? "checkmark correct-check"
                                    : "checkmark incorrect-check"
                                }
                              ></span>
                            ) : (
                              <span className="checkmark"></span>
                            )}
                            <div
                              dangerouslySetInnerHTML={{
                                __html: option?.content,
                              }}
                            />
                          </label>
                        </li>
                      );
                    })}
                  </ul>

                  {userAnswers?.map((itemQ) =>
                    isVisible &&
                      sub_questions?.qid === itemQ?.qid &&
                      sub_questions?.ans_view === "show_ans_with_exp" ? (
                      <div key={itemQ.qid} className="w-100 text-start my-4">
                        <div
                          className={
                            itemQ?.is_user_correct
                              ? "correct p-3"
                              : "incorrect p-3 flex-column align-items-start"
                          }
                        >
                          <span>
                            {itemQ?.is_user_correct ? (
                              <p className="mb-3 fw-bold">
                                {tForLang("course_modules_correct")}
                              </p>
                            ) : (
                              <p className="mb-0 fw-bold">
                                {tForLang("course_modules_incorrect")}
                              </p>
                            )}
                            <span className="mb-0 text-black">
                              <div>
                                {itemQ?.is_user_correct ? (
                                  <div className="my-2">
                                    <p className="mt-2">
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: sub_questions?.crt_ans_exp,
                                        }}
                                      />
                                    </p>
                                  </div>
                                ) : (
                                  <p className="mb-0">
                                    {sub_questions?.wrng_ans_exp && (
                                      <div className="my-2">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: sub_questions?.wrng_ans_exp,
                                          }}
                                        />
                                      </div>
                                    )}
                                  </p>
                                )}
                              </div>
                            </span>
                          </span>
                        </div>
                      </div>
                    ) : null
                  )}

                  {/* Static explanation section */}
                  {/* {isShow && sub_questions?.ans_view === "show_ans_with_exp" ? (
                    <div className="w-100 text-start my-4">
                      <div className={"correct p-3"}>
                        <span>
                          <span className="mb-0 text-black">
                            {tForLang("course_modules_correct_answer")}:
                            <span className="fw-bold">
                              {" "}
                              {sub_questions?.options?.map((option, index) =>
                                option?.is_correct ? (
                                  <span key={option?._id}>
                                    {tForLang("course_modules_option")}{" "}
                                    {index + 1}{" "}
                                  </span>
                                ) : null
                              )}
                            </span>
                            {sub_questions?.ans_view ===
                              "show_ans_with_exp" && (
                                <div>
                                  <p className="mt-3 mb-2"></p>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: sub_questions?.crt_ans_exp,
                                    }}
                                  />
                                  {sub_questions?.wrng_ans_exp && (
                                    <>
                                      <p className="mt-3 mb-2"></p>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: sub_questions?.wrng_ans_exp,
                                        }}
                                      />
                                    </>
                                  )}
                                </div>
                              )}
                          </span>
                        </span>
                      </div>
                    </div>
                  ) : null} */}
                </div>
              ))}
            </ul>
          </div>
        );

        //  case "para":
        // return (
        //   <div>
        //     {length > 1 ? (
        //       <h3 className="fw-bold font-20 text-dark-grey">
        //         {tForLang("course_modules_question")} {`${questionNumber}`}
        //       </h3>
        //     ) : null}
        //     <div dangerouslySetInnerHTML={{ __html: question?.content }} />
        //     <ul className="mcq-questions ps-0">
        //       {question?.sub_questions?.map((sub_questions, index) => (
        //         <div key={index} className="mt-4">
        //            <h3 className="question-label-custom font-18 fw-bold px-2 py-2 mb-3">
        //               {tForLang("course_modules_question")} {`${index + 1}`}
        //             </h3>
        //           <div className="d-flex justify-content-start pt-2">
        //             {/* <span className="fw-semibold me-2">
        //               {`Q. ${index + 1}`}{" "}
        //             </span> */}
        //             <div
        //               className="sub-question"
        //               dangerouslySetInnerHTML={{
        //                 __html: sub_questions?.content,
        //               }}
        //             />
        //           </div>
        //           <ul className="mcq-options">
        //             {sub_questions?.options?.map((option, optIndex) => {
        //               const userAnswerObj = userAnswers.find(
        //                 (ans) => ans.qid === sub_questions.qid
        //               );
        //               const isUserSelected =
        //                 userAnswerObj?.user_answer?.includes(option._id) ||
        //                 (moduleContent?.is_completed &&
        //                   sub_questions?.user_answer?.includes(option._id));
        //               const isCorrect = option?.is_correct;

        //               let className = "mx-3 mt-3 mb-0";

        //               if (
        //                 (showCorrectAnsParam || showVideoAnswerFeedbackParam || moduleContent?.is_completed) &&
        //                 (!sub_questions?.ans_view === "not_show_ans" ||
        //                   sub_questions?.ans_view === "show_ans_with_exp" ||
        //                   sub_questions?.ans_view == "show_ans") &&
        //                 (isShow || isVisible) && 
        //                 ((showCorrectAnsParam && moduleContent?.questions[0]?.sub_questions?.length === userAnswers?.length) || 
        //                  (moduleContent?.is_completed &&
        //                   (userAnswerObj?.user_answer?.length > 0 || sub_questions?.user_answer?.length > 0)))
        //               ) {
        //                 if (isUserSelected) {
        //                   className = isCorrect
        //                     ? "correct-option"
        //                     : "incorrect-option";
        //                 } else if (isCorrect) {
        //                   // For multi-choice questions, always show all correct options
        //                   // For single-choice questions, show correct option if user got it wrong
        //                   if ((sub_questions.question_type === "multi_choice" && moduleContent?.questions[0]?.sub_questions?.length === userAnswers?.length) ||
        //                       (userAnswerObj && !userAnswerObj.is_user_correct) ||
        //                       (moduleContent?.is_completed && 
        //                         (userAnswerObj?.user_answer?.length > 0 || 
        //                           sub_questions?.user_answer?.length > 0) &&
        //                         !sub_questions?.user_answer?.every(
        //                           (ans) =>
        //                             sub_questions?.options?.find(
        //                               (opt) => opt._id === ans
        //                             )?.is_correct
        //                         ))) {
        //                     className = "correct-option";
        //                   }
        //                 }
        //               }

        //               return (
        //                 <li key={optIndex} className={className}>
        //                   <label
        //                     className={
        //                       sub_questions.question_type === "single_choice" ||
        //                         sub_questions.question_type === "bool"
        //                         ? "radio-button-container"
        //                         : "checkbox-button-container"
        //                     }
        //                   >
        //                     <input
        //                       type={
        //                         sub_questions.question_type ===
        //                           "single_choice" ||
        //                           sub_questions.question_type === "bool"
        //                           ? "radio"
        //                           : "checkbox"
        //                       }
        //                       name={`question_${sub_questions._id}`}
        //                       value={option._id}
        //                       disabled={
        //                         moduleContent?.course_test_type === "base_line" ? moduleContent?.is_completed : (sub_questions?.user_answer?.length > 0 || !isSubmit)
        //                       }
        //                       checked={
        //                         userAnswers.find(ans => ans.qid === sub_questions.qid)?.user_answer?.includes(option._id) ||
        //                         sub_questions?.user_answer?.includes(option._id)
        //                       }
        //                       onChange={(e) => {
        //                         const selectedOptions =
        //                           sub_questions?.question_type ===
        //                             "single_choice" ||
        //                             sub_questions.question_type === "bool"
        //                             ? [e.target.value]
        //                             : e.target.checked
        //                               ? [
        //                                 ...(userAnswers.find(
        //                                   (ans) =>
        //                                     ans?.qid === sub_questions.qid
        //                                 )?.user_answer || []),
        //                                 option._id,
        //                               ]
        //                               : (
        //                                 userAnswers.find(
        //                                   (ans) => ans.qid === sub_questions.qid
        //                                 )?.user_answer || []
        //                               ).filter((opt) => opt !== option._id);
        //                         handleOptionSelect(
        //                           sub_questions.qid,
        //                           selectedOptions,
        //                           questionNumber
        //                         );
        //                       }}
        //                     />
        //                     {sub_questions?.user_answer?.length > 0 ? (
        //                       <span
        //                         className={
        //                           option?.is_correct
        //                             ? "checkmark correct-check"
        //                             : "checkmark incorrect-check"
        //                         }
        //                       ></span>
        //                     ) : (
        //                       <span className="checkmark"></span>
        //                     )}
        //                     <div
        //                       dangerouslySetInnerHTML={{
        //                         __html: option?.content,
        //                       }}
        //                     />
        //                   </label>
        //                 </li>
        //               );
        //             })}
        //           </ul>

        //           {userAnswers?.map((itemQ) =>
        //             isVisible &&
        //               sub_questions?.qid === itemQ?.qid &&
        //               sub_questions?.ans_view === "show_ans_with_exp" ? (
        //               <div key={itemQ.qid} className="w-100 text-start my-4">
        //                 <div
        //                   className={
        //                     itemQ?.is_user_correct
        //                       ? "correct p-3"
        //                       : "incorrect p-3 flex-column align-items-start"
        //                   }
        //                 >
        //                   <span>
        //                     {itemQ?.is_user_correct ? (
        //                       <p className="mb-0 fw-bold">
        //                         {tForLang("course_modules_correct")}
        //                       </p>
        //                     ) : (
        //                       <p className="mb-0 fw-bold">
        //                         {tForLang("course_modules_incorrect")}
        //                       </p>
        //                     )}
        //                     <span className="mb-0 text-black">
        //                       <div>
        //                         {itemQ?.is_user_correct ? (
        //                           <div className="my-2">
        //                             <p className="mt-2">
        //                               <div
        //                                 dangerouslySetInnerHTML={{
        //                                   __html: sub_questions?.crt_ans_exp,
        //                                 }}
        //                               />
        //                             </p>
        //                           </div>
        //                         ) : (
        //                           <p className="mb-0">
        //                             {sub_questions?.wrng_ans_exp && (
        //                               <div className="my-2">
        //                                 <div className="incorrect-exp" 
        //                                   dangerouslySetInnerHTML={{
        //                                     __html: sub_questions?.wrng_ans_exp,
        //                                   }}
        //                                 />
        //                               </div>
        //                             )}
        //                           </p>
        //                         )}
        //                       </div>
        //                     </span>
        //                   </span>
        //                 </div>
        //               </div>
        //             ) : null
        //           )}
        //         </div>
        //       ))}

        //       {/* Static explanation section - for main para question */}
        //       {(showCorrectAnsParam || moduleContent?.is_completed) && 
        //       (isShow || isVisible) && (!question?.ans_view === "not_show_ans" ||
        //                   question?.ans_view === "show_ans_with_exp" ||
        //                   question?.ans_view === "show_ans") ? (
        //         <div className="w-100 text-start my-4">
        //           <div className={"common-explanation"}>
        //               <span className="mb-0 text-black">
        //                 {question?.ans_view === "show_ans_with_exp" && (
        //                   <div>
        //                     <p className="fw-bold mt-3 mb-2">Explanation:</p>
        //                     <div
        //                       dangerouslySetInnerHTML={{
        //                         __html: question?.crt_ans_exp,
        //                       }}
        //                     />
        //                   </div>
        //                 )}
        //               </span>
        //           </div>
        //         </div>
        //       ) : null}
        //     </ul>
        //   </div>
        // );

      // case "para":
      //   return (
      //     <div>
      //       {length > 1 ? (
      //         <h3 className="fw-bold font-20 text-dark-grey">{tForLang('course_modules_question')} {`${questionNumber}`}</h3>
      //       ) : null}
      //       <div dangerouslySetInnerHTML={{ __html: question?.content }} />
      //       <ul className="mcq-questions ps-0">
      //         {question?.sub_questions?.map((sub_questions, index) => (
      //           <div className="mt-4">
      //             {/* <h3 className='fw-bold font-20 text-dark-grey'>{`Question ${index + 1}`}</h3> */}
      //             <div className="d-flex justify-content-start pt-2">
      //               <span className="fw-semibold me-2">
      //                 {`Q. ${questionNumber}.${index + 1}`}{" "}
      //               </span>
      //               <div
      //                 className="sub-question"
      //                 dangerouslySetInnerHTML={{
      //                   __html: sub_questions?.content,
      //                 }}
      //               />
      //             </div>
      //             <ul className="mcq-options">
      //               {sub_questions?.options?.map((option, index) => (
      //                 <li key={index} className={question?.user_answer?.includes(option._id)
      //                   ? option?.is_correct
      //                     ? 'correct-option'
      //                     : 'incorrect-option'
      //                   : option?.is_correct
      //                     ? 'correct-option'
      //                     : 'incorrect-option'
      //                 }>
      //                   <label className={
      //                     question.question_type === "single_choice" ||
      //                     question.question_type === "bool"
      //                       ? "radio-button-container"
      //                       : "checkbox-button-container"
      //                   }>
      //                     <input
      //                       type={
      //                         sub_questions.question_type === "single_choice" ||
      //                         sub_questions.question_type === "bool"
      //                           ? "radio"
      //                           : "checkbox"
      //                       }
      //                       name={`question_${sub_questions._id}`}
      //                       value={option._id}
      //                       disabled={sub_questions?.user_answer?.length > 0}
      //                       checked={sub_questions?.user_answer?.find(
      //                         (ans) => ans === option._id
      //                       )}
      //                       onChange={(e) => {
      //                         const selectedOptions =
      //                           sub_questions?.question_type === "single_choice" ||
      //                         sub_questions.question_type === "bool"
      //                             ? e.target.value
      //                             : e.target.checked
      //                             ? [
      //                                 ...(userAnswers.find(
      //                                   (ans) => ans?.qid === sub_questions.qid
      //                                 )?.user_answer || []),
      //                                 option._id,
      //                               ]
      //                             : (
      //                                 userAnswers.find(
      //                                   (ans) => ans.qid === sub_questions.qid
      //                                 )?.user_answer || []
      //                               ).filter((opt) => opt !== option._id);
      //                         handleOptionSelect(
      //                           sub_questions.qid,
      //                           selectedOptions,
      //                           questionNumber
      //                         );
      //                       }}
      //                     />
      //                     {question?.user_answer?.length > 0 ? <span className={option?.is_correct ? 'checkmark correct-check' : 'checkmark incorrect-check'}></span> : <span className="checkmark"></span>}  
                     
      //                     <div
      //                       dangerouslySetInnerHTML={{
      //                         __html: option?.content,
      //                       }}
      //                     />
      //                   </label>
      //                 </li>
      //               ))}

      //               {/* {sub_questions?.user_answer?.map((itemQ) => ( */}

      //               {isShow &&
      //               (sub_questions?.ans_view == "show_ans_with_exp") ? (
      //                 <div className="w-100 text-start my-4">
      //                   <div className={"correct p-3"}>
      //                     <span>
      //                       {/* { <p className='mb-0'>Correct </p> 
      //                : <p className='mb-0'>Incorrect </p>} */}
      //                       {/* {!isCorrect && */}
      //                       <span className="mb-0 text-black">
      //                         {tForLang('course_modules_correct_answer')}:
      //                         <span className="fw-bold">
      //                           {" "}
      //                           {sub_questions?.options?.map((option, index) =>
      //                             option?.is_correct ? (
      //                               <span key={option?._id}>
      //                                 {tForLang('course_modules_option')} {index + 1}
      //                               </span>
      //                             ) : null
      //                           )}
      //                         </span>
      //                {sub_questions?.ans_view ==
      //                         "show_ans_with_exp" ? (
      //                           <div>
      //                             <p className="mt-3 mb-2"></p>
      //                             <div dangerouslySetInnerHTML={{ __html: sub_questions?.crt_ans_exp }} />{" "}
      //                             {<div dangerouslySetInnerHTML={{ __html: sub_questions?.wrng_ans_exp }} /> ? (
      //                               <p className="mt-3 mb-2"></p>
      //                             ) : null}
      //                              <div dangerouslySetInnerHTML={{ __html: sub_questions?.wrng_ans_exp }} />
      //                           </div>
      //                         ) : null}

      //                       </span>
      //                     </span>
      //                   </div>
      //                 </div>
      //               ) : null}
      //               {/* // : null))} */}
      //             </ul>
      //           </div>
      //         ))}
      //       </ul>
      //     </div>
      //   );
      // case 'image-options':
      //   return (
      //     <div>
      //       <h3 className='fw-bold font-26 text-dark-grey'>{`Question ${questionNumber}`}</h3>
      //       <p className='font-16 text-dark-grey'>{`${question.text}`}</p>
      //       {renderImageOptions(question)}
      //     </div>
      //   );
      case "rating":
        return renderSliderFeedback(question, questionNumber, length);
      default:
        return null;
    }
  };

  // Function to check if user's answer is correct
  const checkUserCorrectness = (questionId, selectedOptions) => {
    const question = moduleContent?.questions.find((q) => q.qid === questionId);
    if (!question) {
      console.error(`Question with id ${questionId} not found.`);
      return false;
    }
    const correctOptions = question.options.filter((opt) => opt.is_correct);
    selectedOptions = Array.isArray(selectedOptions)
      ? selectedOptions
      : [selectedOptions];
    // Check if the selected options match the correct options
    return (
      selectedOptions.length === correctOptions.length &&
      selectedOptions.every((opt) =>
        correctOptions.some((co) => co._id === opt)
      )
    );
  };

  const renderImageOptions = (question) => (
    <ul className="mcq-options images ">
      {question.options.map((option, index) => (
        <li key={index}>
          <label>
            <span>
              <input
                type="checkbox"
                name={`question_${question.id}`}
                // value={index}
                onChange={(e) => {
                  const selectedOptions = e.target.checked
                    ? [
                        ...userAnswers.find((ans) => ans.qid === question.qid)
                          ?.user_answer,
                        option._id,
                      ]
                    : userAnswers
                        .find((ans) => ans.qid === question.qid)
                        ?.user_answer.filter((opt) => opt !== option._id);
                  handleOptionSelect(question.qid, selectedOptions);
                }}
                // onChange={() => handleOptionSelect(question.id, index)}
              />
              {option.label}
            </span>
            <span className="position-relative">
              <img
                src={option.image}
                alt={`Option ${index + 1}`}
                onClick={() => handleImageFullScreen(option.image)}
              />
            </span>
          </label>
        </li>
      ))}
    </ul>
  );

  return (
    <div className={moduleContent?.type === "video" ? "module-content video-mode" : "quiz module-content question-mode"}>
      <div dangerouslySetInnerHTML={{ __html: moduleContent?.content }} />
      {console.log("moduleContent==>", moduleContent, courseDetails)}
      {console.log("completedModules==>", completedModules)}
      {/* <hr /> */}
      <form>
        {console.log("questions==>", moduleContent?.questions)}

        
        {moduleContent?.type === "video" ? (
          <Video
            moduleContent={moduleContent}
            renderQuestionContent={renderQuestionContent}
            userAnswers={userAnswers}
            setIsSubmit={setIsSubmit}
            setModuleContent={setModuleContent}
            updateLmsModule={updateLmsModule}
            setCompleted={setCompleted}
            completedModules={completedModules}
            setIsVideoWatchComplete={setIsVideoWatchComplete}
           // moduleContent={selectedModule} 
           // updateLmsModule={() => handleModuleCompletion(selectedModule.module_id)} 
            course={course} 
          />
        ) : (
          moduleContent?.questions?.map((question, index) => (
            <div key={question._id} className="mb-lg-5 mb-4 questions">
              {renderQuestionContent(
                question,
                index + 1,
                moduleContent?.passing_percent,
                moduleContent?.questions?.length || 0,
                moduleContent?.is_completed,
                moduleContent?.is_started,
                moduleContent?.course_test_type
              )}
            </div>
          ))
        )}

        {completed && (
          <Evaluation
            courseDetails={courseDetails}
            Qdata={moduleContent}
            userAns={userAnswers}
            setCompleted={setCompleted}
            updateLmsModule={updateLmsModule}
            setIsVisible={setIsVisible}
            setUserAnswers={setUserAnswers}
            setModuleContent={setModuleContent}
            setIsSubmit={setIsSubmit}
            setRestrictTheSelect={setRestrictTheSelect}
            // onClose={closeOverlay}
            // onSubmit={handleQuizSubmit}
            // showResponse={showResponse}
            // currentQuestion={currentQuestion}
            // isCorrect={isCorrect}
            // continueToVideo={continueToVideo}
          />
        )}
        {console.log("isUserPass", isUserPass)}
        <div className="text-end border-top pt-4 mt-4">
          {!moduleContent?.is_completed &&
            moduleContent?.course_test_type == "end_line" && !isUserPass && (
              <button
                type="button"
                className="btn btn-md btn-primary"
                onClick={() =>
                  isVisible ? retry() : handleMarkAsCompleted(userAnswers, true)
                }
              >
                {isVisible ? tForLang('course_modules_try_again') : tForLang('course_modules_submit')}
              </button>
              
            ) }
          {!moduleContent?.is_completed &&
            moduleContent?.course_test_type == "end_line" && isUserPass && (
              <button
                type="button"
                className="btn btn-md btn-primary"
                onClick={() => updateLmsModule(userAnswers, "test", true)}
              >
                {tForLang('course_modules_next')}
              </button>
          ) }  
          {!moduleContent?.is_completed &&
            moduleContent?.course_test_type == "base_line" && (
              <button
                type="button"
                className={`btn btn-md btn-primary ${isQuizSubmitted ? 'disabled-btn' : ''}`}
                disabled={isQuizSubmitted}
                onClick={() => handleAlreadyMarkAsCompleted(userAnswers, true)}
              >
                 {isQuizSubmitted ? tForLang('course_modules_submit') : tForLang('course_modules_submit')}
              </button>
            )}
          {!moduleContent?.is_completed &&
            moduleContent?.course_test_type == "general_line" && (
              <button
                type="button"
                className={`btn btn-md btn-primary submit-btn ${disabledSubmit || isQuizSubmitted ? 'disabled-btn' : ''}`}
                disabled={disabledSubmit || isQuizSubmitted}
                onClick={() =>
                  handleAlreadyMarkAsCompleted(userAnswers, true, "G")
                }
              >
                {isQuizSubmitted ? tForLang('course_modules_submit') : tForLang('course_modules_submit')}
              </button>
            )}
          {!moduleContent?.is_completed &&
            moduleContent?.course_test_type == "general_line" && (
              <button
                type="button"
                disabled={isSubmit} 
                className={`btn btn-md btn-primary ${!isSubmit ? 'enabled-btn' : 'disabled-btn'}`}
                onClick={() => handleAlreadyMarkAsCompleted(userAnswers, true)}
              >
                 {tForLang('course_modules_next')}
              </button>
            )}
          {moduleContent?.is_completed &&
            (moduleContent?.course_test_type == "general_line" ||
              moduleContent?.course_test_type == "end_line") && (
             (!setIsShow && <button
                type="button"
                className="btn btn-md btn-primary"
                onClick={() => hideShowGeneralQuestion()}
              >
                {showAndHide}
              </button>)
            )}

              {moduleContent?.type === "video" &&
            (() => {
              console.log("Rendering video button with conditions:", {
                moduleType: moduleContent?.type,
                is_completed: moduleContent?.is_completed,
                videoWatchComplete: isVideoWatchComplete,
                userAnswersLength: userAnswers?.length,
                questionsLength:
                  moduleContent?.questions?.length,
                userAnswers: userAnswers,
              });

              // Check if button should be disabled and why
              let isButtonDisabled =
                !moduleContent?.is_completed &&
                (!isVideoWatchComplete ||
                  !userAnswers ||
                  userAnswers.length !==
                  moduleContent?.questions?.length ||
                  userAnswers?.some(
                    (answer) =>
                      !answer.user_answer || answer.user_answer.length === 0
                  ));

              // Check if all questions have empty/invalid video markings
              const allQuestionsHaveInvalidMarkings = moduleContent?.questions?.every(
                (question) => 
                  !question.video_marking || 
                  question.video_marking === " " || 
                  question.video_marking === null || 
                  question.video_marking === undefined ||
                  question.video_marking.trim() === ""
              );

              if (allQuestionsHaveInvalidMarkings && isVideoWatchComplete || course?.course_status === 'completed') {
                isButtonDisabled = false;
                console.log(
                  "All questions have invalid video markings, button enabled after video completion."
                );
              }

              console.log("Video marking status:", {
                allInvalidMarkings: allQuestionsHaveInvalidMarkings,
                questionMarkings: moduleContent?.questions?.map(q => q.video_marking),
                isButtonDisabled
              });

              // Check if user watched video but has unanswered questions
              const hasVideoMarkedQuestions =
                moduleContent?.questions?.some(
                  (question) => question?.video_marking && 
                    question?.video_marking.trim() !== "" && 
                    question?.video_marking !== " "
                );

              const hasUnansweredQuestions =
                isVideoWatchComplete &&
                // !moduleContent?.is_completed &&
                userAnswers &&
                hasVideoMarkedQuestions  &&
                (userAnswers?.length !==
                  moduleContent?.questions?.length ||
                  userAnswers?.some(
                    (answer) =>
                      !answer?.user_answer || answer?.user_answer.length === 0
                  ));

              return (
                <div className="d-flex align-items-center justify-content-end gap-3">
                  {hasUnansweredQuestions && course?.course_status === 'in_progress' && (
                    <div className="text-danger small">
                      <i className="fa fa-exclamation-triangle me-1"></i>
                      {tForLang("course_modules_unanswered_questions_warning")}
                    </div>  
                  )}
                  <button
                    type="button"
                    disabled={isButtonDisabled}
                    className="btn btn-md btn-primary rounded-pill"
                    onClick={() =>
                      handleAlreadyMarkAsCompleted(
                        userAnswers,
                        !moduleContent?.is_completed
                      )
                    }
                  >
                    {tForLang("course_modules_next")}
                  </button>
                </div>
              );
            })()}
         
          {moduleContent?.is_completed && isVideoWatchComplete &&
            moduleContent?.course_test_type !== "in_video" &&
            moduleContent?.type !== "video" && (
              <button
                type="button"
                className="btn btn-md btn-primary rounded-pill "
                onClick={() => handleAlreadyMarkAsCompleted(userAnswers, false)}
              >
                {tForLang("course_modules_next")}
              </button>
            )}
            
          {moduleContent?.is_completed && (
            <button
              type="button"
              className="btn btn-md btn-primary"
              onClick={() => handleAlreadyMarkAsCompleted(userAnswers, false)}
            >
              {tForLang('course_modules_next')}
            </button>
          )}
        </div>
      </form>
      {fullscreenImage && (
        <FullScreenImageModal
          imageUrl={fullscreenImage}
          onClose={handleCloseFullscreen}
        />
      )}
    </div>
  );
};

export default Quiz;

// if => answers is correct => display correct answers explanation
// if => answers is wrong = display wrong answers explanation + correct answer